import React from "react";

import { CampoEstatico, Card, Col, Row, TipoCampoEstatico } from "@intechprev/componentes-web";
import { PlanoVinculadoEntidade } from "../../../../entidades";

interface IProps {
  dataSalario: string;
  valorSalario: number;
  plano: PlanoVinculadoEntidade | null;
}

export const Header: React.FC<IProps> = ({
  dataSalario,
  valorSalario,
  plano
}) => {

  return (
    <Row>
      <Col tamanho={"md-6"}>
        <Card titulo={plano.DS_PLANO}>
          {plano.DS_CATEGORIA}
        </Card>
      </Col>

      <Col tamanho={"md-6"}>
        <Card titulo={"Data de Inscrição"}>
          {plano.DT_INSC_PLANO}
        </Card>
      </Col>
      <Col tamanho={"md-6"}>
        <Card titulo={"Salário de Participação"} tipoBadge={Card.TipoBadge.secondary} textoBadge={dataSalario}>
          <CampoEstatico valor={valorSalario} tipo={TipoCampoEstatico.dinheiro} />
        </Card>
      </Col>
      {/* <Col tamanho={"md-6"}>
        <Card titulo={"Regime de Tributação"}>
          {plano.TIPO_IRRF === "2" ? "Regressivo" : "Progressivo"}
        </Card>
      </Col> */}
    </Row>
  )
}